import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { TransactionState } from '@store/index';

export const AddStateToTransactions = createAction(
  '[AdaptedState] Add State',
  props<{ state: TransactionState }>(),
);

export const UpdateTransactionState = createAction(
  '[AdaptedState] Update State',
  props<{ update: Update<TransactionState> }>(),
);

export const DeleteTransactionState = createAction(
  '[AdaptedState] Delete State',
  props<{ id: string }>(),
);

export const LoadTransactionStates = createAction(
  '[AdaptedState] Load States',
  props<{ states: TransactionState[] }>(),
);

export const ClearTransactionStates = createAction('[AdaptedState] Clear States');

export const SetTransactionId = createAction(
  '[TransactionId] Set transaction id',
  props<{ id: string }>(),
);

export const SetTransactionAsCurrent = createAction(
  '[AdaptedState] Set transaction as current',
  props<{ transaction: TransactionState }>(),
);

export const ClearCurrentTransactionState = createAction(
  '[AdaptedState] Clear current transaction state',
);
